<template>
  <div id="app">
    <page-header></page-header>
    <router-view></router-view>
    <page-footer></page-footer>
  </div>
</template>

<script>
import PageHeader from "@/components/Header"
import PageFooter from '@/components/Footer'

export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter,
  },
  watch: {
    '$route'(to, from) {
      document.title = to.meta.title || 'LKVAL'
    }
  },
}
</script>

<style>
</style>
